export const VALIDATOR_TYPES = {
  greaterThanZero: 'greaterThanZero',
  containsString: 'containsString',
}
